import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=4f9e9d9c&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=4f9e9d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e9d9c",
  null
  
)

export default component.exports